import { css } from 'styled-components';
import { theme, whenHovered, whenFocused, whenActive } from "../../theme";
import { lighten, darken } from 'polished';
export function containedVariant() {
  return css(["", ";", "{", ";}", "{", ";}&[aria-expanded='true'],", "{", ";}", ""], baseStyles, whenHovered, hoverStyles, whenFocused, focusStyles, whenActive, activeStyles, function (p) {
    return p.disabled && "\n      pointer-events: none;\n      color: ".concat(theme.colors.palette.tintA30, ";\n      background-color: ").concat(theme.colors.palette.tintA10, ";\n    ");
  });
}

function baseStyles(p) {
  if (p.$color === 'primary') {
    return css(["background-color:", ";color:", ";"], theme.colors.palette.brandPrimary, theme.colors.palette.grey100);
  }

  if (p.$color === 'error') {
    return css(["background-color:", ";color:", ";"], theme.colors.palette.alertError, theme.colors.palette.grey100);
  }

  if (p.$color === 'neutral') {
    return css(["background-color:", ";color:", ";"], theme.colors.palette.grey00, theme.colors.palette.whiteA80);
  }

  return css(["background-color:", ";color:", ";"], theme.colors.palette.tintA20, theme.colors.palette.tintA80);
}

function hoverStyles(p) {
  if (p.$color === 'primary') {
    return css(["background-color:", ";"], lighten(0.02, theme.colors.palette.brandPrimary));
  }

  if (p.$color === 'error') {
    return css(["background-color:", ";"], lighten(0.02, theme.colors.palette.alertError));
  }

  if (p.$color === 'neutral') {
    return css(["background-color:", ";"], lighten(0.1, theme.colors.palette.grey00));
  }

  return css(["color:", ";background-color:", ";"], theme.colors.palette.tintA80, theme.colors.palette.tintA30);
}

function focusStyles(p) {
  return hoverStyles(p);
}

function activeStyles(p) {
  if (p.$color === 'primary') {
    return css(["background-color:", ";"], darken(0.04, theme.colors.palette.brandPrimary));
  }

  if (p.$color === 'error') {
    return css(["background-color:", ";"], darken(0.04, theme.colors.palette.alertError));
  }

  if (p.$color === 'neutral') {
    return css(["background-color:", ";"], theme.colors.palette.grey00);
  }

  return css(["background-color:", ";"], theme.colors.palette.tintA20);
}